import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Typography from '../../base/Typography';

export const DescriptionList = styled.dl`
  margin: 0 0 0 ${rem(24)};
  padding:0 0 0 ${rem(8)};
`;

export const DescriptionListItems = styled.span`
  display:flex;
`;

export const DescriptionListTypography = styled(Typography)`
  list-style-type: disc;
  display: list-item;
`;

export const DescriptionTerm = styled.dt`
  display:inline;
`;

export const DescriptionDetails = styled.dd`
  display:inline;
  margin:0;
`;
